import Vue from 'vue';
import VueMaterial from 'vue-material';
import VueAnalytics from 'vue-analytics';
import VueResource from 'vue-resource';
import 'vue-material/dist/vue-material.min.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/js/font-size.js';
import './assets/js/device.js';
import './assets/css/reset.css';
import './assets/css/common.css';
import './assets/css/vue-matrial.scss';

import fastclick from 'fastclick';

if ('addEventListener' in document) {
	document.addEventListener('DOMContentLoaded', function() {
		fastclick.attach(document.body);
	}, false);
}

Vue.use(VueMaterial);
Vue.use(VueResource);

Vue.use(VueAnalytics, {
    id: 'UA-125122814-1',
    router,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
